module.exports = __webpack_public_path__ + "img/footer-icon-face.57a1ce99.png";